// extracted by mini-css-extract-plugin
export default {"variantsContainer":"VarsImgQuiz_variantsContainer__sHXf7"};